import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import {History} from 'history';
import contentPartners from '@pluto/content-partners/Redux/ContentPartnersReducer';
import contentTypes from '@pluto/content-types/Redux/ContentTypesReducer';
import notification from '@pluto/notification/Redux/NotificationReducer';
import mrssDefaults from '@pluto/mrss-defaults/Redux/MrssDefaultsReducer';
import users from '@pluto/users/Redux/UsersReducer';
import userDetails from '@pluto/users/Redux/UserReducer';
import genres from '@pluto/genres/Redux/GenresReducer';
import ratingDescriptors from '@pluto/rating-descriptors/Redux/ratingDescriptorsReducer';
import qcMetadataCategories from '@pluto/metadata-categories/Redux/CategoriesReducer';
import {loadingReducer} from '@pluto/loading';
import deliveryManager from 'QCWorkflow/DeliveryManager/Redux/DeliveryManagerReducer';
import deliveryManagerManifest from 'QCWorkflow/DeliveryManager/DeliveryManagerManifest/Redux/DeliveryManagerManifestReducer';
import contentItemsSearchedList from 'ContentItem/ContentItemSearch/Redux/ContentItemSearchReducer';
import contentItemsSearchBarList from 'ContentItem/Search/SearchBar/Redux/SearchBarReducer';
import contentItemsList from 'ContentItem/ContentItemsList/Redux/ContentItemsListReducer';
import contentItem from 'ContentItem/Redux/ContentItemReducer';
import contentItemsSearch from 'ContentItem/Search/Redux/SearchReducer';
import user from 'Login/Redux/LoginReducer';
import textEnums from 'Login/Redux/TextEnumsReducer';
import qcManager from 'QCWorkflow/QCManager/Redux/QCManagerReducer';
import subtitles from 'VideoAudioQC/Timeline/SubtitleTracks/Redux/SubtitleTracksReducer';
import contentPartnersManager from 'ContentPartners/Redux/ContentPartnersReducer';

import ingest from './ingestStore';
import qcJobs from './qcJobsStore';
import qcTools from './qcToolsStore';
import mediaOrders from './mediaOrdersStore';
import timeline from './timelineStore';
import videoAudioQC from './videoAudioQCStore';
import contentItemView from './contentItemViewStore';

const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        user,
        contentPartners,
        contentTypes,
        notification,
        contentItem,
        contentItemsSearchedList,
        contentItemsSearchBarList,
        contentItemsList,
        contentItemsSearch,
        mrssDefaults,
        qcMetadataCategories,
        ingest,
        mediaOrders,
        timeline,
        videoAudioQC,
        qcManager,
        subtitles,
        users,
        userDetails,
        qcJobs,
        qcTools,
        genres,
        ratingDescriptors,
        textEnums,
        deliveryManager,
        deliveryManagerManifest,
        contentPartnersManager,
        contentItemView,
        loading: loadingReducer,
    });

export default createRootReducer;
